import { Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-sidebar-menu-item',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar-menu-item.component.html'
})
export class SidebarMenuItemComponent {
  title = input<string>();
  routeLink = input<string | unknown[]>();
  iconStyles = input<string>();
}
